import logger from "../utils/logger"


export const getStateInfo = (stateModel, state) => {

    logger.info('stateModel: ', stateModel, 'state a traducir: ', state)

    if (stateModel) {
        let statesMapping = stateModel

        const statesMap = statesMapping.find(item => item.state === state)

        logger.info('statesMapping: ', statesMap)


        if (statesMap) {
            return statesMap

        } else {

            const unknown = {
                state: "Unknown",
                stateString: "Unknown",
                buttons: [
                    //{ icon: "how_to_reg", title: "Habilitar" }
                ],
                cssClass: "unknown"
            }
            return unknown
        }


    }

}